import { alpha } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const paperStyles = {
  p: 4,
  mt: 2,
  position: 'relative',
  height: 'calc(65vh / var(--zoom) - 65px)',
  background: abyssColors.neutral[50],
  border: `1px solid ${alpha('#6e8198', 0.25)}`,
  overflow: 'auto',
};

export const editorStyles = {
  height: 'calc(100% - 64px)',
  paddingBottom: '8px',
  overflowY: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
};

export const textFieldStyles = {
  '&.MuiFormControl-root': { width: '100%' },
  '& .MuiInputBase-input': {
    color: abyssColors.primary[500],
  },
  '& .MuiFormLabel-root': {
    color: abyssColors.primary[300],
  },
  '& .MuiInputBase-formControl::before': {
    borderBottom: `1px solid ${abyssColors.primary[100]} !important`,
  },
  '& .MuiInputBase-formControl::after': {
    borderBottom: `1px solid ${abyssColors.primary[100]}`,
  },
};

export const radioButtonStyles = {
  '&.MuiFormControl-root': {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    width: '100%',
  },
  '& .MuiFormControlLabel-root': {
    marginLeft: '-4px',
    marginRight: '24px',
  },
  '& .MuiSvgIcon-root': {
    color: '#0288D1',
  },
  '& label': {
    fontSize: '1.2rem',
  },
};
